import React from "react";
import { Col, Row } from "antd";
import Devices from "../components/devices";

const LightsPage = () => {
  return (
    <Row gutter={[16, 16]} justify="space-between">
      <Col xs={24}>
        <Devices title="Lights" types={"lights"} tabs={false} />
        <br />
      </Col>
    </Row>
  );
};

export default LightsPage;
